var React = require('react');

function Graph (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.85 10.011l9.46 29.424.009.026a3 3 0 005.622.147l5.18-13.704A1.5 1.5 0 0139.498 25h7a1.5 1.5 0 000-3h-7a4.5 4.5 0 00-4.173 2.816l-5.168 13.673-9.459-29.422-.006-.02a3 3 0 00-5.602-.21l-5.2 12.23-.005.01A1.5 1.5 0 018.5 22h-7a1.5 1.5 0 000 3h7a4.5 4.5 0 004.152-2.763L17.85 10.01z"}));
}

Graph.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Graph;

Graph.default = Graph;
